import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateFields } from "../utility/services/Validation";
import { applicationManagement, login } from "../utility/services/apiService";
import { messages } from "../utility/services/message";
import Header from "./layout/Header";
import NavBar from "./layout/NavBar";
import Footer from "./layout/Footer";
import "react-phone-input-2/lib/style.css";
import "react-phone-input-2/lib/bootstrap.css";
import { createNotification } from "./Popup";
import { isError } from "pdfmake/build/pdfmake";
import {
  getAppId,
  getEmail,
  logout,
  setDeclarationInfo,
  setTabID,
  setToken,
  setTStageID,
  setUserInfo,
  setParentInfo,
} from "../utility/Common";

function Continue() {
  let navigate = useNavigate();
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [formData, setFormData] = useState({
    ApplicationId: "",
    EmailAddress: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  useEffect(() => {
    logout()
    setTabID()
  }, [])
  const validationRules = {
    EmailAddress: {
      required: true,
      pattern: emailPattern,
      isConditionMet: true,
      errorMessage: "Barua pepe ni lazima",
      patternErrorMessage: "Barua pepe si sahihi",
    },
    ApplicationId: {
      required: true,
      isConditionMet: true,
      errorMessage: "Nambari ya Ombi  ni lazima",
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateFields(formData, validationRules);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsLoading(true);
      login(formData)
        .then((result) => {
          setIsLoading(false);
          if (result.code === 1) {
            setToken(result?.auth);
            setUserInfo(result.data[0]);
            setParentInfo(result?.data[0])
            if (
              result.data[0]?.ApplicationFrom === 1 ||
              result.data[0]?.ApplicationFrom === 2
            ) {
              let stage = result?.data[0]?.DocStageID;
              setTStageID(stage)
              switch (stage) {
                case 100:
                  navigate("/anuani_ya_sasa", { state: result?.data[0] });
                  break;
                case 110:
                  navigate("/taarifa_za_safari", { state: result?.data[0] });
                  break;
                case 120:
                  const payload = {
                    ApplicationId: getAppId(),
                    EmailAddress: getEmail(),
                  };

                  applicationManagement(payload, "declaration")
                    .then((result) => {
                      setIsLoading(false);
                      if (result.code === 1) {
                        if (result.data) {
                          setDeclarationInfo(result?.data)
                          navigate("/selfDeclaration");
                        } else {
                          const msg = result?.message;
                          const info = { type: "error", message: msg };
                          createNotification(info)();
                        }
                      } else {
                        setIsLoading(false);
                        const msg = result?.message;
                        const info = { type: "error", message: msg };
                        createNotification(info)();
                      }
                    })
                    .catch((error) => {
                      setIsLoading(false);
                      const msg = error?.message;
                      const info = { type: "error", message: msg };
                      createNotification(info)();
                    });
                  break;
                case 130:
                  navigate("/stp10");
                  break;
                case 140:
                  navigate("/stp10");
                  break;
                case 150:
                  navigate("/stp10");
                  break;
                case 160:
                  navigate("/stp10");
                  break;
                case 500:
                  navigate("/stp10");
                  break;
                case 540:
                  navigate("/stp10");
                  break;
                case 550:
                  navigate("/stp10");
                  break;
                case 600:
                  navigate("/stp10");
                  break;

                case 300:
                  navigate("/stp10");
                  break;
                case 610:
                  navigate("/stp10");
                  break;
                case 620:
                  navigate("/stp10");
                  break;
                case 1000:
                  navigate("/stp10");
                  break;
                default:
                  navigate("/continue");
              }
            } else if (result.data[0]?.ApplicationFrom === 3) {
              let stage = result.data[0]?.DocStageID;
              setTStageID(stage)
              switch (stage) {
                case 210:
                  navigate("/stp1B", { state: result?.data[0] });
                  break;
                case 220:
                  navigate("/stp2", { state: result?.data[0] });
                  break;
                case 230:
                  navigate("/stp3", { state: result?.data[0] });
                  break;
                case 240:
                  navigate("/stp4", { state: result?.data[0] });
                  break;
                case 250:
                  navigate("/stp5", { state: result?.data[0] });
                  break;
                case 260:
                  navigate("/stp6", { state: result?.data[0] });
                  break;
                case 500:
                  navigate("/stp10");
                  break;
                case 540:
                  navigate("/stp10");
                  break;
                case 550:
                  navigate("/stp10");
                  break;

                case 300:
                  navigate("/stp10");
                  break;
                case 610:
                  navigate("/stp10");
                  break;
                case 620:
                  navigate("/stp10");
                  break;
                case 1000:
                  navigate("/stp10");
                  break;
                case 270:
                  const payload = {
                    ApplicationId: getAppId(),
                    EmailAddress: getEmail(),
                    Action: "Normal",
                  };

                  applicationManagement(payload, "declaration")
                    .then((result) => {
                      setIsLoading(false);
                      if (result.code === 1) {
                        if (result.data) {
                          setDeclarationInfo(result.data);
                          navigate("/stp7");
                        } else {
                          const msg = result?.message;
                          const info = { type: "error", message: msg };
                          createNotification(info)();
                        }
                      } else {
                        setIsLoading(false);
                        const msg = result?.message;
                        const info = { type: "error", message: msg };
                        createNotification(info)();
                      }
                    })
                    .catch((error) => {
                      setIsLoading(false);
                      const msg = error?.message;
                      const info = { type: "error", message: msg };
                      createNotification(info)();
                    });
                  break;
                case 130:
                  navigate("/stp10");
                  break;
                case 140:
                  navigate("/stp10");
                  break;
                case 150:
                  navigate("/stp10");
                  break;
                case 160:
                  navigate("/stp10");
                  break;
                case 500:
                  navigate("/stp10");
                  break;
                case 540:
                  navigate("/stp10");
                  break;
                case 550:
                  navigate("/stp10");
                  break;
                case 600:
                  navigate("/stp10");
                  break;

                case 300:
                  navigate("/stp10");
                  break;
                case 610:
                  navigate("/stp10");
                  break;
                case 620:
                  navigate("/stp10");
                  break;
                case 1000:
                  navigate("/stp10");
                  break;
                default:
                  navigate("/continue");
              }
            } else if (
              result.data[0]?.ApplicationFrom === 4 ||
              result.data[0]?.ApplicationFrom === 5
            ) {
              let stage = result.data[0]?.DocStageID;
              setTStageID(stage)
              switch (stage) {
                case 210:
                  navigate("/stp1", { state: result?.data[0] });
                  break;
                case 220:
                  navigate("/stp2", { state: result?.data[0] });
                  break;
                case 230:
                  navigate("/stp3", { state: result?.data[0] });
                  break;
                case 240:
                  navigate("/stp4", { state: result?.data[0] });
                  break;
                case 250:
                  navigate("/stp5", { state: result?.data[0] });
                  break;
                case 260:
                  navigate("/stp6", { state: result?.data[0] });
                  break;

                case 300:
                  navigate("/stp10");
                  break;
                case 610:
                  navigate("/stp10");
                  break;
                case 620:
                  navigate("/stp10");
                  break;
                case 1000:
                  navigate("/stp10");
                  break;
                case 270:
                  const payload = {
                    ApplicationId: getAppId(),
                    EmailAddress: getEmail(),
                    Action: "Normal",
                  };

                  applicationManagement(payload, "declaration")
                    .then((result) => {
                      setIsLoading(false);
                      if (result.code === 1) {
                        if (result.data) {
                          setDeclarationInfo(result.data);
                          navigate("/stp7");
                        } else {
                          const msg = result?.message;
                          const info = { type: "error", message: msg };
                          createNotification(info)();
                        }
                      } else {
                        setIsLoading(false);
                        const msg = result?.message;
                        const info = { type: "error", message: msg };
                        createNotification(info)();
                      }
                    })
                    .catch((error) => {
                      setIsLoading(false);
                      const msg = error?.message;
                      const info = { type: "error", message: msg };
                      createNotification(info)();
                    });
                  break;
                case 130:
                  navigate("/stp10");
                  break;
                case 140:
                  navigate("/stp10");
                  break;
                case 150:
                  navigate("/stp10");
                  break;
                case 160:
                  navigate("/stp10");
                  break;
                case 500:
                  navigate("/stp10");
                  break;
                case 540:
                  navigate("/stp10");
                  break;
                case 550:

                case 300:
                  navigate("/stp10");
                  break;
                case 600:
                  navigate("/stp10");
                  break;
                case 610:
                  navigate("/stp10");
                  break;
                case 620:
                  navigate("/stp10");
                  break;
                case 1000:
                  navigate("/stp10");
                  break;
                  navigate("/stp10");
                  break;
                default:
                  navigate("/continue");
              }
            }
          } else {
            const info = { type: "error", message: result?.message };
            createNotification(info)();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          const info = { type: "error", message: messages.networkError };
          createNotification(info)();
        });
    } else {
      const newError = Object.keys(validationErrors);
      createNotification(newError[0] + " " + "is mandatory");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <Header />
      <div className="container">
        <NavBar />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12 module-content2">
            <div
              className="col-md-12 col-sm-12 col-xs-12 tab-registration-container"
              style={{ marginTop: "-5px" }}
            >
              <br />
              {isError && (
                <p style={{ color: "red" }}>
                  <center>{isError}</center>
                </p>
              )}
              <div className="col-sm-6 text-justify">
                <h5 className="page-header m-r-t-1">
                  <a href="/">Ombi la Pasipoti</a>
                </h5>
                <h5 style={{ fontSize: "14px", lineHeight: "1.6" }}>
                  Ili kuweza kuendelea na Ombi lako ulilofanyia maombi ya kwenye
                  mfumo huu wa mtandao, tafadhali weka namba yako ya Ombi
                  sambamba na nambari ya simu ulizojaza wakati unafanya ombi
                  lako.
                </h5>
              </div>
              <div className="col-sm-1"></div>
              <div className="col-sm-5">
                <h5 className="page-header m-r-t-1">
                  <a href="/">Taarifa za Msingi</a>
                </h5>
                <form id="passport-application-form" onSubmit={handleSubmit}>
                  <input type="hidden" name="_csrf" value="" />

                  <div>
                    <div className="form-group field-passportbasicdetails-mobileno required">
                      <label
                        className="control-label"
                        htmlFor="passportbasicdetails-mobileno"
                      >
                        Nambari ya Ombi
                      </label>
                      <input
                        id="ApplicationId"
                        className="form-control"
                        name="ApplicationId"
                        value={formData.ApplicationId}
                        onChange={(e) => {
                          const regex = /^[a-zA-Z0-9]*$/;
                          if (
                            regex.test(e.target.value) ||
                            e.target.value === ""
                          ) {
                            handleChange(e);
                          }
                        }}
                        required
                      />
                      <p className="help-block help-block-error"></p>
                    </div>
                  </div>

                  <div></div>
                  <div className="form-group">
                    <label className="control-label" htmlhtmlFor="EmailAddress">
                      Ingiza barua pepe yako
                    </label>
                    <div
                      type="invalid"
                      style={{
                        color: "red",
                        fontSize: "13px",
                        fontFamily: "time new roman",
                      }}
                    >
                      <i>
                        {errors.EmailAddress && <p>{errors.EmailAddress}</p>}
                      </i>
                    </div>
                    <input
                      type="text"
                      id="EmailAddress"
                      className="form-control"
                      name="EmailAddress"
                      value={formData.EmailAddress}
                      onChange={(e) => {
                        const regex = /^[a-zA-Z0-9.@_-]*$/;
                        if (
                          regex.test(e.target.value) ||
                          e.target.value === ""
                        ) {
                          handleChange(e);
                        }
                      }}
                    />
                    <p className="help-block help-block-error"></p>
                  </div>

                  <div className="box-footer">
                    <button disabled={isLoading} className="btn btn-default btn-label-next pull-right">
                      {isLoading ? "Subiri.." : "Endeleza Ombi |"} {" "}
                      <i className="fa fa-angle-double-right"></i>
                    </button>
                    <br />
                    <div style={{ marginTop: "15px" }}></div>
                  </div>
                </form>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Continue;
